import {
  LayoutDashboard, ShoppingCart, Truck, Package, Landmark,
  BarChart3, Settings, Users, Users2, FileText, Banknote,
  Building2, Wallet, Box, Warehouse, ArrowLeftRight,
  SlidersHorizontal, Coins, Building, Tags, Sliders, Plus, Zap, HelpCircle, ShieldCheck, Printer,
} from 'lucide-react';

export const NAV = [
  {
    id: 'dashboard',
    label: 'Dashboard',
    Icon: LayoutDashboard,
    to: '/dashboard',
  },
  {
    id: 'ventas',
    label: 'Ventas',
    Icon: ShoppingCart,
    children: [
      { label: 'POS',        to: '/ventas/pos',       Icon: Zap      },
      { label: 'Facturas',   to: '/ventas/facturas',  Icon: FileText },
      { label: 'Clientes',   to: '/ventas/clientes',  Icon: Users2   },
      { label: 'Cobranzas',  to: '/ventas/cobranzas', Icon: Banknote },
    ],
  },
  {
    id: 'compras',
    label: 'Compras',
    Icon: Truck,
    children: [
      { label: 'Proveedores', to: '/compras/proveedores', Icon: Building2 },
      { label: 'Facturas',    to: '/compras/facturas',    Icon: FileText  },
      { label: 'Pagos',       to: '/compras/pagos',       Icon: Wallet    },
    ],
  },
  {
    id: 'stock',
    label: 'Stock',
    Icon: Package,
    children: [
      { label: 'Productos',   to: '/stock/productos',   Icon: Box                },
      { label: 'Depósitos',   to: '/stock/depositos',   Icon: Warehouse          },
      { label: 'Movimientos', to: '/stock/movimientos', Icon: ArrowLeftRight     },
      { label: 'Ajustes',     to: '/stock/ajustes',     Icon: SlidersHorizontal  },
    ],
  },
  {
    id: 'tesoreria',
    label: 'Tesorería',
    Icon: Landmark,
    children: [
      { label: 'Cajas',  to: '/tesoreria/cajas',  Icon: Coins    },
      { label: 'Bancos', to: '/tesoreria/bancos', Icon: Building },
    ],
  },
  {
    id: 'reportes',
    label: 'Reportes',
    Icon: BarChart3,
    to: '/reportes',
  },
  {
    id: 'ayuda',
    label: 'Ayuda',
    Icon: HelpCircle,
    to: '/ayuda',
  },
  {
    id: 'configuracion',
    label: 'Configuración',
    Icon: Settings,
    children: [
      { label: 'Usuarios',    to: '/configuracion/usuarios',   Icon: Users      },
      { label: 'Roles',       to: '/configuracion/roles',      Icon: ShieldCheck },
      { label: 'Plantillas',  to: '/configuracion/plantillas', Icon: Printer    },
      { label: 'Categorías',  to: '/configuracion/categorias', Icon: Tags       },
      { label: 'Parámetros',  to: '/configuracion/parametros', Icon: Sliders    },
    ],
  },
];

// Ítems planos para el command palette — navegación
export const PALETTE_NAV = NAV.flatMap(item =>
  item.to
    ? [{ group: 'Navegar', label: item.label, to: item.to, Icon: item.Icon }]
    : (item.children ?? []).map(child => ({
        group: 'Navegar',
        label: `${item.label} › ${child.label}`,
        to: child.to,
        Icon: child.Icon,
      }))
);

// Acciones rápidas
export const PALETTE_ACTIONS = [
  { group: 'Acción rápida', label: 'Nueva factura de venta',  to: '/ventas/facturas?new=1',       Icon: Plus },
  { group: 'Acción rápida', label: 'Nuevo cliente',           to: '/ventas/clientes?new=1',        Icon: Plus },
  { group: 'Acción rápida', label: 'Nueva factura de compra', to: '/compras/facturas?new=1',       Icon: Plus },
  { group: 'Acción rápida', label: 'Nuevo proveedor',         to: '/compras/proveedores?new=1',    Icon: Plus },
  { group: 'Acción rápida', label: 'Nuevo producto',          to: '/stock/productos?new=1',        Icon: Plus },
  { group: 'Acción rápida', label: 'Ajuste de stock',         to: '/stock/ajustes?new=1',          Icon: Plus },
  { group: 'Acción rápida', label: 'Movimiento de caja',      to: '/tesoreria/cajas?new=1',        Icon: Plus },
  { group: 'Acción rápida', label: 'Centro de ayuda',         to: '/ayuda',                        Icon: HelpCircle },
];

export const ALL_PALETTE_ITEMS = [...PALETTE_ACTIONS, ...PALETTE_NAV];
